var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLockIcon = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 174.72 230.05",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.92,94.53h-.72V63.84A63.84,63.84,0,0,0,87.36,0h0A63.84,63.84,0,0,0,23.52,63.84V94.53H22.8A22.8,22.8,0,0,0,0,117.33v89.92a22.8,22.8,0,0,0,22.8,22.8H151.92a22.8,22.8,0,0,0,22.8-22.8V117.33A22.8,22.8,0,0,0,151.92,94.53Zm-61.2,67.75v21.05a3.85,3.85,0,0,1-3.84,3.84h0A3.85,3.85,0,0,1,83,183.33V162a14.41,14.41,0,1,1,7.68.26ZM124.8,94.53H49V62.37A37.92,37.92,0,0,1,86.88,24.45h0A37.92,37.92,0,0,1,124.8,62.37Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLockIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/lock_icon.1ec6f598.svg";
export { ForwardRef as ReactComponent };